var e={img:"styles-module_img__IV4Ho",loaded:"styles-module_loaded__74rEy",show:"styles-module_show__ECGKa",placeholderImage:"styles-module_placeholderImage__r-ani",spinner:"styles-module_spinner__BEnaX"};export{e as default};
//# sourceMappingURL=styles.module.scss.js.map
